import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined,
    TeamOutlined,
    UserOutlined,
    CreditCardOutlined,
    DeleteOutlined,
    LogoutOutlined,
    ExclamationCircleFilled
} from '@ant-design/icons';
import { FaAffiliatetheme, FaShoppingCart } from 'react-icons/fa';
import { TbCards } from "react-icons/tb";
import { FaPeopleGroup } from "react-icons/fa6";
import { MdLanguage } from 'react-icons/md';
import { DiMaterializecss } from "react-icons/di";
import { PiFlagBannerFill } from 'react-icons/pi';
import { Modal } from 'antd';
import { logout } from '../../api/AdminRequest';
import logo from "../../assests/zeeqrLogo.png";
import './Sidebar.css';

const { confirm } = Modal;

function SidebarNew() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const scrollRef = useRef(null);  // 1. Add a ref for the scroll container
    // const scrollPosRef = useRef(0);  // 2. Track scroll position

   useEffect(() => {
    const saved = sessionStorage.getItem('sidebar-scroll');
    if (scrollRef.current && saved) {
        scrollRef.current.scrollTop = parseInt(saved, 10);
    }
}, [location.pathname]);

    const menuItems = [
        { label: 'Dashboard', path: '/dashboard', icon: <PieChartOutlined /> },
        { label: 'Admins Profile', path: '/view-admins', icon: <TeamOutlined /> },
        { label: 'Users Profile', path: '/active-users', icon: <UserOutlined /> },
        { label: 'Orders', path: '/orders', icon: <CreditCardOutlined /> },
        { label: 'All Cards', path: '/all-cards', icon: <TbCards /> },
        { label: 'Coupons', path: '/coupons', icon: <CreditCardOutlined /> },
        { label: 'ZQR-Products', path: '/view-products', icon: <FaShoppingCart /> },
        { label: 'Products', path: '/products', icon: <FaShoppingCart /> },
        { label: 'Banner', path: '/banner', icon: <PiFlagBannerFill /> },
        { label: 'Themes', path: '/themes', icon: <FaAffiliatetheme /> },
        { label: 'Language', path: '/languages', icon: <MdLanguage /> },
        { label: 'Materials', path: '/materials', icon: <DiMaterializecss /> },
        { label: 'Visitors Data', path: '/visitors', icon: <FaPeopleGroup /> },
        { label: 'Trash', path: '/trash', icon: <DeleteOutlined /> },
    ];

    const handleSignOut = () => {
        confirm({
            title: "Do you Want to Signout",
            icon: <ExclamationCircleFilled />,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk() {
                const signout = async () => {
                    try {
                        const refToken = await localStorage.getItem("admin-refToken");
                        const { data } = await logout(refToken);
                        if (data.success) {
                            localStorage.clear();
                            navigate("/");
                        }
                    } catch (error) {
                        console.log(error?.response?.data);
                        localStorage.clear();
                        navigate("/");
                    }
                };
                signout();
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };
    const handleScroll = () => {
    if (scrollRef.current) {
        sessionStorage.setItem('sidebar-scroll', scrollRef.current.scrollTop);
    }
};

    const handleMenuClick = (path) => {
        if (path === '/signout') {
            handleSignOut();
        } else {
            navigate(path);
            setMobileMenuOpen(false);
        }
    };

    // const handleMenuClick = (path) => {
    //     // 4. Save scroll position before navigating
    //     if (scrollRef.current) {
    //         scrollPosRef.current = scrollRef.current.scrollTop;
    //     }

    //     if (path === '/signout') {
    //         handleSignOut();
    //     } else {
    //         navigate(path);
    //         setMobileMenuOpen(false);
    //     }
    // };

    const isActive = (path) => location.pathname === path;

    return (
        <>
            {/* Mobile Menu Button */}
            <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-gray-800 text-white hover:bg-gray-700 transition-colors"
            >
                {mobileMenuOpen ? <MenuFoldOutlined className="text-xl" /> : <MenuUnfoldOutlined className="text-xl" />}
            </button>

            {/* Mobile Overlay */}
            {mobileMenuOpen && (
                <div
                    className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
                    onClick={() => setMobileMenuOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`
                    fixed top-0 left-0 h-screen bg-[#001529] text-white z-40
                    transition-all duration-300 ease-in-out
                    flex flex-col
                    ${collapsed ? 'w-20' : 'w-[270px]'}
                    ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
                `}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-700">
                    {!collapsed && (
                        <div className="flex items-center">
                            <img src={logo} alt="Logo" className="h-10 w-auto" />
                        </div>
                    )}
                    <button
                        onClick={() => setCollapsed(!collapsed)}
                        className="hidden lg:block p-2 hover:bg-gray-700 rounded-lg transition-colors ml-auto"
                    >
                        {collapsed ? (
                            <MenuUnfoldOutlined className="text-lg" />
                        ) : (
                            <MenuFoldOutlined className="text-lg" />
                        )}
                    </button>
                </div>

                {/* Menu Items */}
                <div
                    ref={scrollRef}
                    onClick={handleScroll}
                    className="flex-1 overflow-y-auto overflow-x-hidden py-4 hide-scrollbar"
                    style={{
                        scrollbarWidth: 'none', /* Firefox */
                        msOverflowStyle: 'none', /* IE and Edge */
                    }}
                >
                    <nav className="space-y-1 px-2">
                        {menuItems.map((item) => (
                            <button
                                key={item.path}
                                onClick={() => handleMenuClick(item.path)}
                                className={`
                                    w-full flex items-center gap-3 px-3 py-3 rounded-lg
                                    transition-all duration-200
                                    ${isActive(item.path)
                                        ? 'bg-blue-600 text-white'
                                        : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                                    }
                                    ${collapsed ? 'justify-center' : ''}
                                `}
                                title={collapsed ? item.label : ''}
                            >
                                <span className="text-lg flex-shrink-0">
                                    {item.icon}
                                </span>
                                {!collapsed && (
                                    <span className="text-sm font-medium truncate">
                                        {item.label}
                                    </span>
                                )}
                            </button>
                        ))}

                        {/* Sign Out */}
                        <button
                            onClick={() => handleMenuClick('/signout')}
                            className={`
                                w-full flex items-center gap-3 px-3 py-3 rounded-lg
                                transition-all duration-200
                                text-gray-300 hover:bg-red-600 hover:text-white
                                ${collapsed ? 'justify-center' : ''}
                            `}
                            title={collapsed ? 'Sign Out' : ''}
                        >
                            <span className="text-lg flex-shrink-0">
                                <LogoutOutlined />
                            </span>
                            {!collapsed && (
                                <span className="text-sm font-medium truncate">
                                    Sign Out
                                </span>
                            )}
                        </button>
                    </nav>
                </div>
            </div>

            {/* Spacer for desktop to prevent content overlap */}
            <div className={`hidden lg:block flex-shrink-0 transition-all duration-300 ${collapsed ? 'w-20' : 'w-[270px]'}`} />
        </>
    );
}

export default SidebarNew;